import React from "react";

const NotFound = () => {
  return <div>Error 404 , The requested url was not found !</div>;
};

export default NotFound;
